import { Component, Input, OnDestroy, OnInit } from "@angular/core"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { Subscription } from "rxjs"
import { Localize } from "../../models/localize.model"
import { CookiesService } from "../../services/cookies.service"
import { LocalizationService } from "../../services/localization.service"
import { UserService } from "../../services/user.service"
import { AuthModalComponent } from "../modals/auth-modal/auth-modal.component"
import { LocalizationModalComponent } from "../modals/localization-modal/localization-modal.component"

@Component({
    selector: "app-localization",
    templateUrl: "./localization.component.html",
    styleUrls: ["./localization.component.less"],
})
export class LocalizationComponent implements OnInit, OnDestroy {
    @Input() public addWrapper: boolean = false

    public subscriptions: Subscription[] = []
    public localizeData: Localize = new Localize([])
    public logoUrl: string = ""
    public gtmPrefix: string = "gtm-homepage-station-module-"
    public isUserLoggedIn: boolean = false

    constructor(
        private cookieService: CookiesService,
        private localizationService: LocalizationService,
        private modalService: NgbModal,
        private userService: UserService
    ) {}

    public ngOnInit() {
        this.isUserLoggedIn = this.userService.isLoggedIn()

        this.subscriptions.push(
            this.localizationService.localizeData.subscribe((data) => {
                this.localizeData = data
                this.logoUrl = this.localizeData.getLogo()
            })
        )
    }

    public hasImage() {
        return this.localizeData.hasFreeAreaImage()
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }

    public openLocalizationChangeModal() {
        this.modalService.open(LocalizationModalComponent, {
            size: "lg",
            windowClass: "change-station-modal",
        })
    }

    public openAuthModal() {
        const modalRef = this.modalService.open(AuthModalComponent)
    }
}
